'use client';

import * as React from 'react';

// TODO: Use Remove `update: any` for the update method once `useStore` uses `ReadonlyStore`

export const SchedulerStoreContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") SchedulerStoreContext.displayName = "SchedulerStoreContext";
export function useSchedulerStoreContext(optional = false) {
  const context = React.useContext(SchedulerStoreContext);
  if (context == null && !optional) {
    throw /* FIXME (minify-errors-in-prod): Unminified error message in production build! */new Error('MUI: useSchedulerStoreContext must be used within an <EventCalendar /> or a <EventTimelinePremium /> component');
  }
  return context;
}